import { render, staticRenderFns } from "./plan-editor.vue?vue&type=template&id=4032045b"
import script from "./plan-editor.vue?vue&type=script&lang=js"
export * from "./plan-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports